// prod
const ESP_SDK = 'https://feedback.esp.vmware.com/assets/ipf/esp.js';
const CLIENT_ID = 'esp-prod-124-bxnsq';

// staging
// const ESP_SDK = 'https://feedback.esp-staging.vmware-aws.com/assets/ipf/esp.js';
// const CLIENT_ID = 'esp-stg-227-fzrbf';

export default {
  ESP_SDK,
  CLIENT_ID
};
